import { SegmentedControl } from "./SegmentedControl";

const OPTIONS = [
  { value: "3", label: "3d" },
  { value: "7", label: "7d" },
  { value: "14", label: "14d" },
  { value: "30", label: "30d" },
] as const;

/** Compare-window selector (current N vs prior N). Filters sit above the charts. */
export function RangePicker({
  days,
  onChange,
}: {
  days: number;
  onChange: (days: number) => void;
}) {
  return (
    <SegmentedControl
      ariaLabel="Compare window"
      options={OPTIONS}
      value={String(days)}
      onChange={(v) => onChange(Number(v))}
    />
  );
}
